/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled, { CSSProperties } from "styled-components";
import { Button, Text, theme } from "@nordcloud/gnui";

const Wrapper = styled(Button)`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 100%;
  min-height: 8rem;
  max-width: 30rem;
  padding: ${theme.spacing.spacing04};
  border: 1px solid ${theme.color.background.ui04};
  transition: ${theme.transition};
  background-color: ${theme.color.background.ui03};
  border-color: ${theme.color.border.border01};

  &:hover {
    filter: none;
    background-color: ${theme.color.background.ui04};
  }
`;

type Props = {
  label: string;
  subLabel?: string;
  description?: string;
  disabled?: boolean;
  wrapperStyle?: CSSProperties;
  onClick?: () => void;
};

export function TextBox({
  subLabel,
  label,
  description,
  disabled = false,
  wrapperStyle,
  onClick,
}: Props) {
  return (
    <Wrapper
      onClick={onClick}
      type="button"
      disabled={disabled}
      style={wrapperStyle}
    >
      <Text align="left" size="xs" color={theme.color.text.text02}>
        {subLabel}
      </Text>
      <Text
        align="left"
        size="md"
        weight="medium"
        color={theme.color.text.text01}
      >
        {label}
      </Text>
      <Text
        css={{ whiteSpace: "normal" }}
        align="left"
        size="sm"
        color={theme.color.text.text02}
      >
        {description}
      </Text>
    </Wrapper>
  );
}
